import { useForm } from './form'

export function useFormInput(inputElement) {
  const formElement = getFormElement(inputElement)
  const form = useForm(formElement)

  // Get all the dependencies that belong to this input
  const dependencies = form?.dependencies?.filter(dep => dep.matches(inputElement)) || []

  // Use to configure a this input to listen to all dependent changes. This will trigger a change
  // for every type of dependency - e.g changing values, options, etc.
  const onDependentChange = listener => {
    const subscriptions = []
    dependencies.forEach(dep => {
      subscriptions.push(dep.subscribeToFormUpdates(() => listener(dep)))
    })

    return () => subscriptions.forEach(unsub => unsub())
  }

  return { onDependentChange, dependencies, form, formElement }
}

function getFormElement(inputElement) {
  const formId = inputElement.getAttribute('form')
  const formElement = formId ? document.getElementById(formId) : inputElement.closest('form')

  return formElement
}
